exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 10; }\n", ""]);

// exports
